import React, { useState, useEffect, Fragment } from "react";
import styles from '../assets/css/module/common.module.css';
import { IsNotNull, INNRD } from "../helpers/common/helper";
import { useParams } from 'react-router-dom';
import FnBList from "../components/bar/fnb-list";
import dayjs from "dayjs";
import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { cryptr_encrypt } from "../controllers/commons/encrypt/encrypt";
import { getQR } from '../components/QR/QR';
import EnjoyMeal from '../assets/img/enjoy-meal.png';

const FnBController = require('../controllers/fnb/fnb');

const Order = () => {
  let { p1 } = useParams();
  const [food, setFood] = useState(null)
  const [beverage, setBeverage] = useState(null)
  const [dessert, setDessert] = useState(null)
  const [listFood, setListFood] = useState([])
  const [listBeverage, setListBeverage] = useState([])
  const [listDessert, setListDessert] = useState([])
  const [expiredSession, setExpiredSession] = useState(null)
  const [submitted, setSubmitted] = useState(null)
  const [taken, setTaken] = useState(null)
  const [OL, setOL] = useState(null)
  const [disableSubmit, setDisableSubmit] = useState(false)
  const [QR, setQR] = useState(<div>QR Not Available</div>)

  async function getOrderData(b) {
    try {
      const order_data = await FnBController.getOrderListData(b);

      if (IsNotNull(order_data)) {
        setOL(order_data)
        setSubmitted(order_data.ol_submitted)
        setTaken(order_data.ol_taken)
        setExpiredSession(dayjs(order_data.ol_expired))

        if (order_data.ol_submitted) {
          cryptr_encrypt().encrypt(order_data.ol_id).then(enc => {
            setQR(getQR(enc, 200, 200));
          });
        }

        if (IsNotNull(order_data.ol_location)) {
          let b = {
            p1: order_data.ol_location
          }

          await Promise.all([
            FnBController.getListFood(b).then(a => IsNotNull(a) && setListFood(a)),
            FnBController.getListBeverage(b).then(a => IsNotNull(a) && setListBeverage(a)),
            FnBController.getListDessert(b).then(a => IsNotNull(a) && setListDessert(a))
          ]);
        }
      }

      // await FnBController.getOrderListData(b).then(async x => {
      //   if (IsNotNull(x)) {
      //     setOL(x)
      //     setSubmitted(x.ol_submitted)
      //     setTaken(x.ol_taken)
      //     setExpiredSession(dayjs(x.ol_expired))
      //     if (x.ol_submitted) {
      //       let enc = await cryptr_encrypt().encrypt(x.ol_id)
      //       let rs = getQR(enc, 200, 200)
      //       setQR(rs)
      //     }
      //     if (IsNotNull(x.ol_location)) {
      //       let b = {
      //         p1: x.ol_location
      //       }

      //       async function getListFood() {
      //         await FnBController.getListFood(b).then(a => {
      //           if (IsNotNull(a)) {
      //             setListFood(a)
      //           }
      //         })
      //       }
      //       async function getListBeverage() {
      //         await FnBController.getListBeverage(b).then(a => {
      //           if (IsNotNull(a)) {
      //             setListBeverage(a)
      //           }
      //         })
      //       }
      //       async function getListDessert() {
      //         await FnBController.getListDessert(b).then(a => {
      //           if (IsNotNull(a)) {
      //             setListDessert(a)
      //           }
      //         })
      //       }
      //       getListFood()
      //       getListBeverage()
      //       getListDessert()
      //     }
      //   }
      // })
    } catch (error) {
      console.error("Data fetching failed:", error);
    }
  }

  function checkSubmit() {
    let rs = true
    rs = IsNotNull(food) || IsNotNull(beverage) || IsNotNull(dessert)
    return rs
  }

  async function submitSelection() {
    if (checkSubmit()) {
      try {
        setDisableSubmit(true)
        let b = {
          p1: OL.ol_id,
          p2: IsNotNull(food) ? food.fnb_id : null,
          p3: IsNotNull(beverage) ? beverage.fnb_id : null,
          p4: IsNotNull(dessert) ? dessert.fnb_id : null,
          p5: OL.e_id,
          p6: OL.ol_location
        }
        await FnBController.submitOrder(b).then(x => {
          if (IsNotNull(x)) {
            switch (x.code) {
              case 'U-01':
                enqueueSnackbar('Submit Success', { variant: "success", autoHideDuration: 3000 })
                let b = {
                  p1: OL.ol_id
                }
                getOrderData(b)
                break;
              default:
                enqueueSnackbar(x.message, { variant: "error", autoHideDuration: 2000 })
                break;
            }
          } else {
            enqueueSnackbar(x.message, { variant: "error", autoHideDuration: 2000 })
          }
        })
      } catch (error) {
        enqueueSnackbar('Submit Failed', { variant: "error", autoHideDuration: 2000 })
      } finally {
        setDisableSubmit(false)
      }
    } else {
      enqueueSnackbar('Please Choose Your Food Menu', { variant: "error", autoHideDuration: 2000 })
    }
  }

  useEffect(() => {
    async function getDataOrder() {
      let b = { p1: p1 }
      await getOrderData(b)
    }
    if (IsNotNull(p1)) {
      getDataOrder()
    }
  }, [p1]);

  // useEffect(() => {
  //   async function getDataOrder() {
  //     let b = { p1: p1 }
  //     await getOrderData(b)
  //   }
  //   if (IsNotNull(p1)) {
  //     getDataOrder()
  //   }

  // }, [p1])

  return (
    <Fragment>
      <SnackbarProvider anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }} />
      <div className={`${styles['flx-h-c']}`}>
        <div className={`${styles['order-container']}`} />
        <div className={`${styles['order-content']} ${styles['col-80']} `}>
          {
            dayjs() < dayjs(expiredSession) ?
              IsNotNull(taken) && taken ?
                <div className={`${styles['taken-meal-sec']}`}><img src={EnjoyMeal} width={'200px'} alt="" /></div> :
                IsNotNull(submitted) && submitted ?
                  <div>
                    <div className={`${styles['qr-sec']}`}>
                      <div className={`${styles['qr-container']}`}>
                        <div className={`${styles['qr-component']}`}>{QR}</div>
                        <span >Scan Before Picking Up Your Meals</span>
                        <div className={`${styles['od-container']}`}>
                          <div className={`${styles['od-title']}`}>YOUR ORDER</div>
                          <div className={`${styles['od-data']}`}>{OL.food_name}</div>
                          <div className={`${styles['od-data']}`}>{OL.beverage_name}</div>
                          <div className={`${styles['od-data']}`}>{OL.dessert_name}</div>
                        </div>
                      </div>
                    </div>
                    <div>
                    </div>
                  </div>
                  :
                  <div className={`${styles['menu-list-container']}`}>
                    <div className={`${styles['order-list-layout']}`}>
                      <div className={`${styles['order-list-fnb-container']}`}>
                        <div className={`${styles['order-list-detail']}`}>
                          <span className={`${styles['order-list-title']}`}>COMPLIMENTARY MEALS</span>
                          <div className={`${styles['order-list-detail-name']}`}>{IsNotNull(OL) ? `Hi ${INNRD(OL.e_name, '-')}` : '-'}</div>
                          <div className={`${styles['order-list-detail-name']}`}>Please Select Your Meals</div>
                        </div>

                        <span className={`${styles['order-list-fnb-title']}`}>FOOD</span>
                        <div className={`${styles['order-list-menu-container']}`}>
                          {
                            listFood.map((x) => {
                              return (
                                <FnBList
                                  key={x.fnb_id}
                                  title={x.fnb_title}
                                  desc={x.fnb_desc}
                                  qty={INNRD(x.stock_balance, 0)}
                                  obj={x}
                                  className={`${styles['col-4']}`}
                                  selectedMenu={food}
                                  setter={setFood}
                                />
                              )
                            })
                          }
                        </div>
                      </div>
                      {
                        listBeverage.length > 0 ?
                          <div className={`${styles['order-list-fnb-container']}`}>
                            <span className={`${styles['order-list-fnb-title']}`}>BEVERAGE</span>
                            <div className={`${styles['order-list-menu-container']}`}>
                              {
                                listBeverage.map((x) => {

                                  return (
                                    <FnBList
                                      key={x.fnb_id}
                                      title={x.fnb_title}
                                      desc={x.fnb_desc}
                                      qty={INNRD(x.stock_balance, 0)}
                                      obj={x}
                                      className={`${styles['col-4']}`}
                                      selectedMenu={beverage}
                                      setter={setBeverage}
                                    />
                                  )
                                })
                              }
                            </div>
                          </div> : null
                      }
                      {
                        listDessert.length > 0 ?
                          <div className={`${styles['order-list-fnb-container']}`}>
                            <span className={`${styles['order-list-fnb-title']}`}>DESSERT</span>
                            <div className={`${styles['order-list-menu-container']}`}>
                              {
                                listDessert.map((x) => {
                                  return (
                                    <FnBList
                                      key={x.fnb_id}
                                      title={x.fnb_title}
                                      desc={x.fnb_desc}
                                      qty={INNRD(x.stock_balance, 0)}
                                      obj={x}
                                      className={`${styles['col-4']}`}
                                      selectedMenu={dessert}
                                      setter={setDessert}
                                    />
                                  )
                                })
                              }
                            </div>
                          </div> : null
                      }
                    </div>
                  </div>
              : <div className={`${styles['flex']} ${styles['flx-c']}`}> URL EXPIRED </div>
          }
        </div>
        {
          dayjs() < dayjs(expiredSession) ?
            !taken ?
              !submitted ?
                <div className={`${styles['order-submit-container']}`}>
                  <button onClick={submitSelection} disabled={disableSubmit}>SUBMIT</button>
                </div>
                : null : null : null
        }
      </div>
    </Fragment >
  )
}

export default Order
